import AEIcon from '@app/components/Phone/icons/AE.svg';
import AMIcon from '@app/components/Phone/icons/AM.svg';
import ATIcon from '@app/components/Phone/icons/AT.svg';
import AZIcon from '@app/components/Phone/icons/AZ.svg';
import BEIcon from '@app/components/Phone/icons/BE.svg';
import BGIcon from '@app/components/Phone/icons/BG.svg';
import BYIcon from '@app/components/Phone/icons/BY.svg';
import CAIcon from '@app/components/Phone/icons/CA.svg';
import CNIcon from '@app/components/Phone/icons/CN.svg';
import UnknownIcon from '@app/components/Phone/icons/country.svg';
import CYIcon from '@app/components/Phone/icons/CY.svg';
import CZIcon from '@app/components/Phone/icons/CZ.svg';
import DEIcon from '@app/components/Phone/icons/DE.svg';
import EEIcon from '@app/components/Phone/icons/EE.svg';
import ESIcon from '@app/components/Phone/icons/ES.svg';
import FIIcon from '@app/components/Phone/icons/FI.svg';
import GBIcon from '@app/components/Phone/icons/GB.svg';
import GEIcon from '@app/components/Phone/icons/GE.svg';
import GRIcon from '@app/components/Phone/icons/GR.svg';
import HRIcon from '@app/components/Phone/icons/HR.svg';
import IDIcon from '@app/components/Phone/icons/ID.svg';
import ILIcon from '@app/components/Phone/icons/IL.svg';
import ITIcon from '@app/components/Phone/icons/IT.svg';
import KGIcon from '@app/components/Phone/icons/KG.svg';
import KZIcon from '@app/components/Phone/icons/KZ.svg';
import LTIcon from '@app/components/Phone/icons/LT.svg';
import LVIcon from '@app/components/Phone/icons/LV.svg';
import MDIcon from '@app/components/Phone/icons/MD.svg';
import MEIcon from '@app/components/Phone/icons/ME.svg';
import PLIcon from '@app/components/Phone/icons/PL.svg';
import ROIcon from '@app/components/Phone/icons/RO.svg';
import RSIcon from '@app/components/Phone/icons/RS.svg';
import RUIcon from '@app/components/Phone/icons/RU.svg';
import TRIcon from '@app/components/Phone/icons/TR.svg';
import UAIcon from '@app/components/Phone/icons/UA.svg';
import USIcon from '@app/components/Phone/icons/US.svg';
import { CountryAlpha2 } from '@app/types';

const RUSSIA_FLAG = '🇷🇺';
const ARMENIA_FLAG = '🇦🇲';
const UAE_FLAG = '🇦🇪';
const UKRAINE_FLAG = '🇺🇦';
const BELARUS_FLAG = '🇧🇾';
const ITALY_FLAG = '🇮🇹';
const GRECE_FLAG = '🇬🇷';
const GERMANY_FLAG = '🇩🇪';
const GREAT_BRITAIN_FLAG = '🇬🇧';
const KIRGIZSTAN_FLAG = '🇰🇬';
const CROATIA_FLAG = '🇭🇷';
const INDONESIA_FLAG = '🇮🇩';
const LATVIA_FLAG = '🇱🇻';
const AZERBAIJAN_FLAG = '🇦🇿';
const SERBIA_FLAG = '🇷🇸';
const LITHUANIA_FLAG = '🇱🇹';
const GEORGIA_FLAG = '🇬🇪';
const USA_FLAG = '🇺🇸';
const TURKEY_FLAG = '🇹🇷';
const ESTONIA_FLAG = '🇪🇪';
const CANADA_FLAG = '🇨🇦';
const KAZAKHSTAN_FLAG = '🇰🇿';
const SPAIN_FLAG = '🇪🇸';
const FINLAND_FLAG = '🇫🇮';
const CZECH_REPUBLIC_FLAG = '🇨🇿';
const AUSTRIA_FLAG = '🇦🇹';
const BULGARIA_FLAG = '🇧🇬';
const MOLDOVA_FLAG = '🇲🇩';
const CYPRUS_FLAG = '🇨🇾';
const MONTENEGRO_FLAG = '🇲🇪';
const ISRAEL_FLAG = '🇮🇱';
const CHINA_FLAG = '🇨🇳';
const UNKNOWN_FLAG = '🌍';
const BELGIUM_FLAG = '🇧🇪';
const ROMANIA_FLAG = '🇷🇴';
const POLAND_FLAG = '🇵🇱';

export const COUNTRY_SYMBOL_FLAGS: Record<CountryAlpha2, string> = {
  AM: ARMENIA_FLAG,
  AZ: AZERBAIJAN_FLAG,
  BY: BELARUS_FLAG,
  CA: CANADA_FLAG,
  CN: CHINA_FLAG,
  DE: GERMANY_FLAG,
  EE: ESTONIA_FLAG,
  ES: SPAIN_FLAG,
  FI: FINLAND_FLAG,
  GE: GEORGIA_FLAG,
  GR: GRECE_FLAG,
  ID: INDONESIA_FLAG,
  IT: ITALY_FLAG,
  KG: KIRGIZSTAN_FLAG,
  LT: LITHUANIA_FLAG,
  LV: LATVIA_FLAG,
  RU: RUSSIA_FLAG,
  RS: SERBIA_FLAG,
  TR: TURKEY_FLAG,
  UA: UKRAINE_FLAG,
  US: USA_FLAG,
  HR: CROATIA_FLAG,
  CZ: CZECH_REPUBLIC_FLAG,
  AE: UAE_FLAG,
  GB: GREAT_BRITAIN_FLAG,
  KZ: KAZAKHSTAN_FLAG,
  AT: AUSTRIA_FLAG,
  BG: BULGARIA_FLAG,
  MD: MOLDOVA_FLAG,
  CY: CYPRUS_FLAG,
  ME: MONTENEGRO_FLAG,
  IL: ISRAEL_FLAG,
  BE: BELGIUM_FLAG,
  RO: ROMANIA_FLAG,
  PL: POLAND_FLAG,
  [CountryAlpha2.UNKNOWN]: UNKNOWN_FLAG,
};

export const COUNTRY_ICONS: Record<CountryAlpha2, string> = {
  AM: AMIcon,
  AZ: AZIcon,
  BY: BYIcon,
  CA: CAIcon,
  CN: CNIcon,
  DE: DEIcon,
  EE: EEIcon,
  ES: ESIcon,
  FI: FIIcon,
  GE: GEIcon,
  GR: GRIcon,
  ID: IDIcon,
  IT: ITIcon,
  KG: KGIcon,
  LT: LTIcon,
  LV: LVIcon,
  RU: RUIcon,
  RS: RSIcon,
  TR: TRIcon,
  UA: UAIcon,
  US: USIcon,
  HR: HRIcon,
  CZ: CZIcon,
  AE: AEIcon,
  GB: GBIcon,
  KZ: KZIcon,
  AT: ATIcon,
  BG: BGIcon,
  MD: MDIcon,
  CY: CYIcon,
  ME: MEIcon,
  IL: ILIcon,
  BE: BEIcon,
  RO: ROIcon,
  PL: PLIcon,
  [CountryAlpha2.UNKNOWN]: UnknownIcon,
};
